import { Container, Row } from "reactstrap";
import SimpleAccordion from "./SimpleAccordion";
import { Breadcrumbs } from "../../../AbstractElements";
import { Accordion, UIKits } from "../../../Constants/Constants";
import FlushAccordion from "./FlushAccordion";
import MultipleCollapse from "./MultipleCollapse";
import IconAccordion from "./IconAccordion";
import OutlineAccordion from "./OutlineAccordion";
import HorizontalAccordion from "./HorizontalAccordion";
import CollapesAccordion from "./CollapesAccordion";
import { Fragment } from "react/jsx-runtime";

const AccordionContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={Accordion} parent={UIKits} />
      <Container fluid>
        <Row>
          <SimpleAccordion />
          <FlushAccordion />
          <MultipleCollapse />
          <IconAccordion />
          <OutlineAccordion />
          <HorizontalAccordion />
          <CollapesAccordion />
        </Row>
      </Container>
    </Fragment>
  );
};
export default AccordionContainer;
